// Mock audit trail data for development and testing
export type AuditTrailEntry = {
  dateTime: string;
  user: string;
  action: string;
  fileFieldValue: string;
  details: string;
};

export const auditTrailEmpty: AuditTrailEntry[] = [];

export const auditTrail4: AuditTrailEntry[] = [
  {
    dateTime: '2024-06-27 16:21:03',
    user: 'importer@namsa.com',
    action: 'Uploaded DICOM file',
    fileFieldValue: 'DOESNOTEXIST.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:22:10',
    user: 'alice@example.com',
    action: 'Deleted DICOM file',
    fileFieldValue: 'brain_scan.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:23:15',
    user: 'bob@example.com',
    action: 'Viewed DICOM file',
    fileFieldValue: 'chest_xray.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:24:20',
    user: 'admin@example.com',
    action: 'Uploaded DICOM file',
    fileFieldValue: 'new_file.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:25:30',
    user: 'charlie@example.com',
    action: 'Viewed DICOM file',
    fileFieldValue: 'patient_001.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:26:45',
    user: 'diana@example.com',
    action: 'Uploaded DICOM file',
    fileFieldValue: 'mri_scan.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:27:12',
    user: 'emma@example.com',
    action: 'Deleted DICOM file',
    fileFieldValue: 'old_scan.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:28:33',
    user: 'frank@example.com',
    action: 'Viewed DICOM file',
    fileFieldValue: 'xray_chest.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:29:18',
    user: 'grace@example.com',
    action: 'Uploaded DICOM file',
    fileFieldValue: 'ct_scan.dcm',
    details: '[Download]',
  },
  {
    dateTime: '2024-06-27 16:30:22',
    user: 'henry@example.com',
    action: 'Viewed DICOM file',
    fileFieldValue: 'ultrasound.dcm',
    details: '[Download]',
  },
];

export const auditTrail50: AuditTrailEntry[] = Array.from(
  { length: 50 },
  (_, i) => ({
    dateTime: '2024-06-27 16:21:03',
    user: 'importer@namsa.com',
    action: 'Uploaded DICOM file',
    fileFieldValue: `MOCK_FILE_${i + 1}.dcm`,
    details: '[Download]',
  })
);
